import { useEffect } from "react";

import { useFormikContext } from "formik";

import { getFieldsWithServerError, scrollToError } from "./utils";

interface ScrollToErrorFieldProps {
  formRef: React.RefObject<HTMLFormElement | null>;
}

const ScrollToErrorField = ({ formRef }: ScrollToErrorFieldProps) => {
  const { submitCount, isValid, errors, status } = useFormikContext();

  useEffect(() => {
    const fieldsWithServerError = getFieldsWithServerError(status);
    if (!formRef.current || (isValid && fieldsWithServerError.length === 0)) {
      return;
    }

    scrollToError(formRef, errors as Record<string, unknown>, status);
  }, [submitCount]);

  return null;
};

export default ScrollToErrorField;
